export const isAntdFormValidationError = (error) =>
  Array.isArray(error?.errorFields);

export const runAntdFormAction = (action) =>
  Promise.resolve()
    .then(action)
    .catch((error) => {
      if (isAntdFormValidationError(error)) return undefined;
      throw error;
    });
